
import dynamic from "next/dynamic";
import Head from "next/head";

const DynamicDesktop = dynamic(() =>
  import("@/components/HomeLanding/HomeLandingPage")
);
const DynamicMobile = dynamic(() =>
  import("@/components/HomeLanding/MobileHomeLandingPage")
);

export default function HomeLandingIndia({ mobileView }) {
  return (
    <>
       <Head>
         <title>Modern POS Billing Software in Dubai & UAE - Start Free Today</title>
        <meta
          name="description"
          content="Experience the world’s most trusted Android POS software in Dubai & UAE. Seamless billing, inventory, payments, loyalty & online store – works online & offline."
        />
        <link rel="canonical" href="https://queuebuster.co/ae-en" />
        <link rel="alternate" href="https://queuebuster.co/ae-en" hrefLang="en-us" />
        <meta
          property="og:title"
          content="Most Modern POS Billing Software in Dubai & UAE | Android POS for Seamless Growth"
        />
        <meta
          property="og:description"
          content="Empower your business in Dubai & UAE with the most reliable Android POS billing software. From billing to inventory, loyalty to payments – QueueBuster makes growth unstoppable"
        />
        <meta
          property="og:url"
          content="https://queuebuster.co/ae-en"
        />
        <meta
          property="og:image"
          content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/UAE+OG+Images.png"
        />
        {/* D&B DUNS Registered Seal Script */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
              var script = document.createElement('script');
              script.src = 'https://dunsregistered.dnb.com';
              script.type = 'text/javascript';
              document.head.appendChild(script);
            `,
          }}
        />
      </Head>
       
      {mobileView ? <DynamicMobile /> : <DynamicDesktop />}
    </>
  );
}
